<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5 bg-error text-white">
        Delete Selected Items
      </v-card-title>
      
      <v-card-text class="pt-4">
        Are you sure you want to delete these {{ count }} selected items?
        <div class="text-caption mt-2 text-grey-darken-1">
          This action cannot be undone.
        </div>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey-darken-1"
          variant="text"
          @click="$emit('cancel')"
          :disabled="deleting"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          variant="elevated"
          @click="$emit('confirm')"
          :loading="deleting"
        >
          Delete All
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteSelectedItemsDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      required: true
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel']
}
</script>
